import { User } from './User.types';

export const isAuthenticated = (user: User | null) => {
    if (!user) {
        return false;
    }

    if (user.expiration && new Date().getTime() > user.expiration * 1000) {
        return false;
    }

    if (sessionStorage.getItem('after_redirect')) {
        const afterRedirect = sessionStorage.getItem('after_redirect');
        if (afterRedirect) {
            window.location.href = afterRedirect;
            sessionStorage.removeItem('after_redirect');
        }
    }

    return true;
};
